module.exports = __webpack_public_path__ + "static/media/bechofylogo.b5951bfc.png";